var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("monthly-icome"),
        state: _vm.getState(_vm.$v.recipient.monthly_income),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.monthly_income),
        required: "",
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          mask: "R$ ############",
          name: "founding_date",
          readonly: _vm.disabled,
          disabled: _vm.disabled,
        },
        on: { input: () => _vm.$v.recipient.monthly_income.$touch() },
        model: {
          value: _vm.recipient.monthly_income,
          callback: function ($$v) {
            _vm.$set(_vm.recipient, "monthly_income", $$v)
          },
          expression: "recipient.monthly_income",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }